import { render, staticRenderFns } from "./RecipeFilterLite.vue?vue&type=template&id=56ad48bc"
import script from "./RecipeFilterLite.vue?vue&type=script&lang=js"
export * from "./RecipeFilterLite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports